import { agentSetupActionTypes as ACTION } from '../actionTypes';
import { studioSetupActionTypes as STUDIOACTION } from '../actionTypes';

const initialState = {
  agent: {
    loading: false,
    data: null,
    error: '',
  },
  studio: {
    loading: false,
    data: null,
    error: '',
  },
};

const DownloadReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION.AGENT_FETCH_DOWNLOAD_REQUEST:
      return {
        ...state,
        agent: {
          ...state.agent,
          loading: true,
        },
      };
    case ACTION.AGENT_FETCH_DOWNLOAD_SUCCESS:
      return {
        ...state,
        agent: {
          loading: false,
          data: action.payload,
          error: '',
        },
      };
    case ACTION.AGENT_FETCH_DOWNLOAD_FAILURE:
      return {
        ...state,
        agent: {
          loading: false,
          data: null,
          error: action.payload,
        },
      };

    case STUDIOACTION.STUDIO_FETCH_DOWNLOAD_REQUEST:
      return {
        ...state,
        studio: {
          ...state.studio,
          loading: true,
        },
      };
    case STUDIOACTION.STUDIO_FETCH_DOWNLOAD_SUCCESS:
      return {
        ...state,
        studio: {
          loading: false,
          data: action.payload,
          error: '',
        },
      };
    case STUDIOACTION.STUDIO_FETCH_DOWNLOAD_FAILURE:
      return {
        ...state,
        studio: {
          loading: false,
          data: null,
          error: action.payload,
        },
      };

    default:
      return state;
  }
};

export default DownloadReducer;
